import { Box, Container } from '@mui/material';
import { useEffect } from 'react';
import { Outlet, useParams } from 'react-router-dom';
import { useSettingsContext } from 'src/legacy/components/settings';
import { getFosterFamily } from 'src/legacy/redux/slices/fosterFamily';
import { useDispatch } from 'src/legacy/redux/store';

import { BasicInfoCard } from './BasicInfoCard';
import { Breadcrumbs } from './Breadcrumbs';
import { FosterFamilyDetailsNavigatorContextProvider } from './FosterFamilyDetailsNavigatorContext';
import { Tabs } from './Tabs';

export const FosterFamilyDetailsNavigator = () => {
  const dispatch = useDispatch();
  const { id } = useParams();
  const { themeStretch } = useSettingsContext();

  useEffect(() => {
    if (id) {
      dispatch(getFosterFamily(Number(id)));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  return (
    <FosterFamilyDetailsNavigatorContextProvider>
      <Container maxWidth={themeStretch ? false : 'lg'}>
        <Breadcrumbs />

        <BasicInfoCard />

        <Tabs />

        <Box>
          <Outlet />
        </Box>
      </Container>
    </FosterFamilyDetailsNavigatorContextProvider>
  );
};
